"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_1 = __importDefault(require("../base/model"));
const queue_stats_schema_1 = require("./queue-stats.schema");
class QueueStats extends model_1.default {
    serialize() {
        const obj = super.serialize();
        //Render ID as just queue ID without instanceID
        obj.ID = obj.ID.split('/')[1];
        delete obj.ttl;
        return obj;
    }
}
exports.default = QueueStats;
QueueStats.schema = queue_stats_schema_1.QueueStatsSchema;
